import classNames from 'classnames/bind';
import styles from './TotalCorrectRate.module.css';
import TipButton from '../../../components/TipButton';
import { TOTAL_CORRECT_RATE } from '../../../constants';

interface TotalCorrectRate {
  rate: string;
}

export default function TotalCorrectRate({ rate }: TotalCorrectRate) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx('correct_guide')}>
      <TipButton name="totalCorrectRate" />
      <span>{TOTAL_CORRECT_RATE} : </span>
      <span className={cx('correct_rate')}>{rate}</span>
    </div>
  );
}
